
import Vue from 'vue'

export default Vue.extend({
  props: {
    direction: {
      type: String,
      required: true,
    },
  },
  methods: {
    click() {
      this.$emit('click')
    },
  },
})
